import Masonry from '../../../../vendor/masonry';

export default () => {
    const homeBillboard = document.querySelector('.homeBillboard .images__inner');

    if (homeBillboard) {
        const msnryHomeBillboard = new Masonry( homeBillboard, {
            itemSelector: '.image',
            gutter: 16,
            horizontalOrder: true,
            percentPosition: true,
            originTop: false
        });
    }

    const metrics = document.querySelectorAll('._metrics__cards.-offset');

    if (metrics) {
        metrics.forEach((metric) => {
            const msnryMetrics = new Masonry( metric, {
                itemSelector: '.metric-card',
                gutter: 16,
                horizontalOrder: true,
                percentPosition: true
            });
        });
    }

    const smartTeasers = document.querySelectorAll('._smartTeaser__teasers.-vertical');

    if (smartTeasers) {
        smartTeasers.forEach((smartTeaser) => {
            const msnryTeasers = new Masonry( smartTeaser, {
                itemSelector: '._smartTeaser__teaser',
                gutter: 24,
                horizontalOrder: true,
                percentPosition: true
            });
        });
    }
}